import { UserSettings } from './../../models/UserSettings';
import { SettingsProvider } from './../../providers/settings/settings';
import { ViewController, LoadingController, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { UserProvider } from '../../providers/user/user';
import { Subscription } from 'rxjs/Subscription';
import { UserSubscriptionComponent } from './../../components/user-subscription/user-subscription';


/**
 * Generated class for the UserAppSettingsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
	selector: 'user-app-settings',
	templateUrl: 'user-app-settings.html'
})
export class UserAppSettingsComponent {

	settings: UserSettings;
	hasAccess: boolean = false;
	rxSub: Subscription = null;

	constructor(
		public viewCtrl: ViewController,
		public settingsCtrl: SettingsProvider,
		private userCtrl: UserProvider,
		public loadingCtrl: LoadingController,
		public modalCtrl: ModalController,

	) {
		let loader = this.loadingCtrl.create();
		loader.present();

		//Enusre permission for certain settings
		this.rxSub = combineLatest([
			this.userCtrl.hasAccess(),
			this.settingsCtrl.getUserSettings()
		]).subscribe(
			([hasAccess, settings]) =>{
				this.settings = settings;
				this.hasAccess = hasAccess;
				loader.dismiss();
			},
			(error) => {
				console.warn(error)
				loader.dismiss();
			}
		);
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	setSettings(event) {
		this.settingsCtrl.setUserSettings(this.settings).first().subscribe();
	}

	openSubscriptionModal(){
		combineLatest([
			this.userCtrl.getUser(),
			this.userCtrl.getSubscription()
		]).first().subscribe(([user, sub]) => 
			{
		  		let modal = this.modalCtrl.create(UserSubscriptionComponent, {user, sub});
		  		modal.present();
			}
		)
	  }

	ngOnDestroy(){
		if(this.rxSub) this.rxSub.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/components/user-app-settings/user-app-settings.ts